<template>
  <div v-if="schedule.length" class="streams-schedule__groups">
    <div v-for="(group, groupIndex) in schedule" :key="groupIndex" class="streams-schedule__group">
      <span class="streams-schedule__group--time">{{ group.time }}</span>
      <div class="streams-schedule__group--entries">
        <div v-for="(item, itemIndex) in group.items" :key="itemIndex" class="streams-schedule__item">
          <div class="streams-schedule__item-image-col">
            <HeadlineIcons :headline="item" class="U-display-none U-display-lg-block" />
            <HeadlineIcons :headline="item" size="small" class="U-display-lg-none" />
            <HeadlineImage class="streams-schedule__item-image" :href="item.href" :headline="item" :picture-srcset="{ xs: { w: 220, h: 220 } }" />
          </div>
          <div class="streams-schedule__item-content-col">
            <HeadlineLabels :labels="[item.primaryCategory.name]" class="streams-schedule__item-category" />
            <HeadlineTitle class="streams-schedule__item-title" :headline="item" title-size="h5" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="streams-schedule__empty">
    <h3>Transliacijų nėra</h3>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { HeadlineIcons, HeadlineImage, HeadlineLabels, HeadlineTitle } from '@headlines/components/fragments';

interface Props {
  schedule: Array<Record<string, any>>;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  components: {
    HeadlineIcons,
    HeadlineImage,
    HeadlineLabels,
    HeadlineTitle,
  },
  props: {
    schedule: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
});
</script>
<style lang="scss">
.streams-schedule {
  &__empty {
    padding: 65px 0;
    border: 1px solid #dedfe0;
    border-radius: 10px;
    text-align: center;

    h3 {
      margin: 0;
      font-size: 20px;
      line-height: 20px;
      color: #708597;
    }
  }

  &__groups {
    padding: 0 20px;
    border: 1px solid #dedfe0;
    border-radius: 10px;

    @include media-breakpoint-down(xs) {
      padding: 0 15px;
    }
  }

  &__group {
    display: flex;
    border-bottom: 1px solid #dedfe0;

    &:last-child {
      border-bottom: 0;
    }

    @include media-breakpoint-down(xs) {
      flex-direction: column;
    }

    &--time {
      margin-right: 30px;
      padding: 20px 0 0 0;
      color: #708597;
      font-size: 16px;
      font-weight: 500;

      @include media-breakpoint-down(xs) {
        padding: 15px 0 0 0;
        font-size: 14px;
      }
    }

    &--entries {
      display: flex;
      overflow-x: scroll;

      @include media-breakpoint-down(xs) {
        flex-direction: column;
        overflow: hidden;
      }
    }
  }

  &__item {
    display: flex;
    margin-right: 30px;
    padding: 20px 0;
    min-width: 300px;

    @include media-breakpoint-down(xs) {
      padding: 15px 0;
      min-width: unset;
    }

    &:last-child {
      margin-right: 0;
    }

    &-image-col {
      @include make-col-ready();
      @include make-col-custom(110px);
      padding: 0;
      height: 110px;
      overflow: hidden;
      border-radius: 10px;
    }

    &-image {
      padding-bottom: get-picture-padding(110, 110);

      .C-image-decoration {
        display: none;
      }
    }

    &-content-col {
      @include make-col-ready();
      @include make-col-dynamic();

      display: flex;
      flex-direction: column;
      justify-content: center;
      max-width: 450px;
      padding: 0 0 0 20px;

      @include media-breakpoint-down(xs) {
        @include make-col-dynamic();
      }
    }

    &-category {
      margin-bottom: 10px;

      .C-headline-labels__label {
        margin: 0;
      }
    }

    &-title {
      color: #050f19;
      font-size: 15px;
      font-weight: 700;
      line-height: 21px;

      h5 {
        margin: 0;
      }
    }
  }
}
</style>
